import { render, staticRenderFns } from "./AboutMission.vue?vue&type=template&id=40d8e1b2&scoped=true&"
import script from "./AboutMission.vue?vue&type=script&lang=ts&"
export * from "./AboutMission.vue?vue&type=script&lang=ts&"
import style0 from "./AboutMission.vue?vue&type=style&index=0&id=40d8e1b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d8e1b2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AboutMissionList: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/about/AboutMissionList.vue').default})
